// Shared by ExportAries.vue (standalone Exporter tab) and Groups.vue (Forecast
// app quick action). The ARIES qualifier is never user-entered -- it's derived
// from the method and technique slugs: AX_<FAMILY><version>_<TECHNIQUE>,
// e.g. ("advanced5", "mmh") -> AX_ADV5_MMH, ("hyper5a", "auto") -> AX_HYPER5A_AUTO.
const FAMILY_PREFIXES = [
  ['advanced', 'ADV'],
  ['hyper', 'HYPER'],
  ['multi', 'MULTI'],
  ['arps', 'ARPS'],
]

// Only techniques with a long name need an entry here. Anything else (including
// techniques added later) just falls back to its own slug uppercased.
const TECHNIQUE_ABBREVIATIONS = {
  optimized: 'OPT',
  auto: 'AUTO',
}

// Same abbreviation as deriveAriesQualifier() below, minus the "AX_"
// prefix -- for names that aren't themselves ARIES qualifiers (e.g. a
// type curve's TYPE_CURVE value).
export function deriveMethodTechniqueAbbr(methodSlug, techniqueSlug) {
  if (!methodSlug) return null
  let slug = String(methodSlug).toLowerCase()
  let abbr = null
  for (let [prefix, tag] of FAMILY_PREFIXES) {
    if (slug.startsWith(prefix)) {
      abbr = `${tag}${slug.slice(prefix.length).toUpperCase()}`
      break
    }
  }
  // Unrecognized method family -- fall back to the whole slug.
  if (abbr === null) abbr = slug.toUpperCase()

  if (techniqueSlug) {
    let technique = String(techniqueSlug).toLowerCase()
    abbr += `_${TECHNIQUE_ABBREVIATIONS[technique] || technique.toUpperCase()}`
  }
  return abbr
}

export function deriveAriesQualifier(methodSlug, techniqueSlug) {
  let abbr = deriveMethodTechniqueAbbr(methodSlug, techniqueSlug)
  return abbr ? `AX_${abbr}` : null
}
